const _ = require('lodash');
const GranularDimension = require('../rtImporter/granularDimension');
const GranularDimensionSet = require('../rtImporter/granularDimensionSet');
const SharedConstants = require('../rtImporter/constants');

const Constants = {
	...SharedConstants,
	DIM_NAME_START: 'rlv_g_', // "Magic" start of a GAM key-value used by us
	DEFAULT_MAX_CUSTOM_DIMS: 10, // Max active custom dimensions in GAM
	DEFAULT_MAX_VALUES_PER_DIM: 200, // Max number of key-value values in GAM
	DEFAULT_MAX_CUSTOM_COMBOS: 20000, // Max key-value combinations in GAM
	DEFAULT_MAX_CHARS_PER_VAL: 40, // Max value length in GAM
};

/** Is "our" GAM key-value */
const isMyKey = (name) => name?.startsWith(Constants.DIM_NAME_START);

/** Our enabled GAM key-values */
const enabledDimSettings = (dimSettings) => dimSettings
	.filter((d) => d.name && d.enabled && d.values?.length && isMyKey(d.customKeyName));

/** Group enabled 'dimSettings' according to GAM key-value key name - converted to GranularDimension objects. */
const toDimGroups = (dimSettings) => _.values(
	_.groupBy(enabledDimSettings(dimSettings)
		.map((dim) => new GranularDimension(dim.toObject?.() || dim)), 'customKeyName'),
);

/** GranularDimensionSet from 'dimSettings' */
const toDimSet = (dimSettings) => new GranularDimensionSet(toDimGroups(dimSettings));

/** Creates an "id map" from 'existingIdMap' with any new mappings needed to support 'dimSettings' added. */
const idMapWithDims = (existingIdMap, dimSettings) => {
	const newMap = {};
	let [nextKey, nextVal] = ['keyToId', 'valToId'].map((fld) => {
		const existing = existingIdMap?.[fld];
		newMap[fld] = { ...existing };
		return (_.max(_.filter(_.values(existing).map(Number))) || 0) + 1;
	});
	dimSettings?.forEach(({ name, values }) => {
		if (!newMap.keyToId[name]) {
			newMap.keyToId[name] = (nextKey++).toString();
		}
		values.forEach((val) => {
			if (!newMap.valToId[val]) {
				newMap.valToId[val] = (nextVal++).toString();
			}
		});
	});
	return newMap;
};

module.exports = {
	Constants,
	isMyKey,
	idMapWithDims,
	enabledDimSettings,
	toDimGroups,
	toDimSet,
};
